export type SiteArtwork = { bitcasino: string } & Partial<
  Record<Exclude<Site, "bitcasino">, string>
>;

export const RANK_ICON_IMAGES: Record<"default" | 1 | 2 | 3, SiteArtwork> = {
  1: {
    bitcasino:
      "https://heathmont.imgix.net/cms/media/image%20312(2).png?q=80&auto=format%2Ccompress",
    sportsbet:
      "https://heathmont.imgix.net/cms/media/Lvl1_Steel_512.png?q=80&auto=format%2Ccompress",
  },
  2: {
    bitcasino:
      "https://heathmont.imgix.net/cms/media/image%20312(1)-1.png?q=80&auto=format%2Ccompress",
    sportsbet:
      "https://heathmont.imgix.net/cms/media/Lvl1_Steel_512(1).png?q=80&auto=format%2Ccompress",
  },
  3: {
    bitcasino:
      "https://heathmont.imgix.net/cms/media/image%20312-1.png?q=80&auto=format%2Ccompress",
    sportsbet:
      "https://heathmont.imgix.net/cms/media/Lvl1_Steel_512(2).png?q=80&auto=format%2Ccompress",
  },
  default: {
    bitcasino:
      "https://heathmont.imgix.net/cms/media/image%20313-1.png?q=80&auto=format%2Ccompress",
    sportsbet:
      "https://heathmont.imgix.net/cms/media/image%20310.png?q=80&auto=format%2Ccompress",
  },
};

export const RANK_BADGE_IMAGES: SiteArtwork = {
  bitcasino:
    "https://heathmont.imgix.net/cms/media/BC_BG_Rank.png?q=80&auto=format%2Ccompress",
  sportsbet:
    "https://heathmont.imgix.net/cms/media/SB_BG_RANK.png?q=80&auto=format%2Ccompress",
};

export function siteArtwork(artwork: SiteArtwork, site: Site): string {
  return artwork[site] ?? artwork.bitcasino;
}
